import { create } from 'zustand';

type OpenChatState = {
  chatId: string | null;
  setChatId: (chatId: string | null) => void;
};

export const useOpenChatStore = create<OpenChatState>((set) => ({
  chatId: null,
  setChatId: (chatId) => set({ chatId }),
}));
